import acpPaypalRestAuthTemplate from './templates/acp-paypal-rest-auth.html';
import { PaypalRestAuthStateParams } from './types';

export function acpPaypalRestAuthStates($stateProvider: any) {
  'ngInject';

  $stateProvider.state('public.paypal-rest-auth', {
    controller: 'AcpPaypalRestAuthCtrl',
    controllerAs: 'vm',
    template: acpPaypalRestAuthTemplate,
    url: '/paypal/authenticate?code&error',
    data: {
      gaLocation: 'paypal-rest-auth'
    },
    params: {
      code: undefined,
      error: undefined
    } as PaypalRestAuthStateParams,
    resolve: {
      module: /* @ngInject */ ($ocLazyLoad) => {
        return import(
          /* webpackChunkName: "acp.section.paypal-rest-auth" */ 'sections/paypal-rest-auth'
        ).then($ocLazyLoad.loadModule);
      }
    }
  });
}
